import { Injectable } from '@angular/core';
import { NeighbourModelsInfo, Page } from '@app/core/interfaces/page.interface';
import { SpecialBlock } from '@core/models/block/special-block';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PageService {
  page = new BehaviorSubject<Page>(null);
  cookies: Record<string, BehaviorSubject<SpecialBlock>> = {};
  menu: Record<string, Record<number, BehaviorSubject<SpecialBlock>>> = {};
  defaultMenu: Record<string, BehaviorSubject<SpecialBlock>> = {};
  footer: Record<string, BehaviorSubject<SpecialBlock>> = {};
  neighbourModels = new BehaviorSubject<NeighbourModelsInfo>(null);
  private missingFooterLocales = new Set<string>();

  saveMenu(menu: SpecialBlock) {
    if (!this.menu[menu.locale]) {
      this.menu[menu.locale] = {};
    }
    if (!this.menu[menu.locale][menu.id]) {
      this.menu[menu.locale][menu.id] = new BehaviorSubject<SpecialBlock>(null);
    }
    this.menu[menu.locale][menu.id].next(menu);

    if (menu.isDefault) {
      this.setDefaultMenu(menu);
    }
  }

  getMenu(id: number, locale: string) {
    return this.menu[locale]?.[id]?.value || null;
  }

  private setDefaultMenu(menu: SpecialBlock) {
    if (!this.defaultMenu[menu.locale]) {
      this.defaultMenu[menu.locale] = new BehaviorSubject<SpecialBlock>(null);
    }
    this.defaultMenu[menu.locale].next(menu);
  }

  getDefaultMenu(locale: string) {
    return this.defaultMenu[locale]?.value || null;
  }

  saveCookies(cookie: SpecialBlock) {
    if (!this.cookies[cookie.locale]) {
      this.cookies[cookie.locale] = new BehaviorSubject<SpecialBlock>(null);
    }
    this.cookies[cookie.locale].next(cookie);
  }

  getCookies(locale: string) {
    return this.cookies[locale]?.value || null;
  }

  saveFooter(footer: SpecialBlock) {
    if (!this.footer[footer.locale]) {
      this.footer[footer.locale] = new BehaviorSubject<SpecialBlock>(null);
    }
    this.footer[footer.locale].next(footer);
  }

  getFooter(locale: string) {
    return this.footer[locale]?.value || null;
  }

  // Klient bez stopki dostaje z API 404, którego nie da się zapisać jak zwykłej stopki —
  // bez tej pamięci każda nawigacja pytałaby o stopkę od nowa i płaciła pełny koszt 404.
  markFooterMissing(locale: string) {
    this.missingFooterLocales.add(locale);
  }

  isFooterMissing(locale: string): boolean {
    return this.missingFooterLocales.has(locale);
  }
}
